import { CheckboxControl } from "@/components/CheckboxControl/CheckboxControl"
import { PPSTransitionRecord, createPPSTransitionRecords, updatePPSTransitionRecords } from "@/services/project/PPSTransition.service"
import { store } from "@/store"
import { getFSContentSelector, getTopologyState } from "@/store/flowsheet/flowsheet.slice"
import { Col, Form, Modal, Row, Select } from "antd"
import { useEffect, useMemo, useState } from "react"
import { useSelector } from "react-redux"


interface TransitionModalProps {
  trigger?: JSX.Element
  simId: number
  record?: PPSTransitionRecord
  onSuccess?: () => void
  onCancel?: () => void
}

export const TransitionModal = (props: TransitionModalProps) => {
  const {trigger, simId, record, onSuccess, onCancel} = props;
  const [show, setShow] = useState(false || !!record)
  const [form] = Form.useForm();
  const simulationData = useSelector(getTopologyState)
    

  useEffect(() => {
    if (!record) return;
    form.setFieldsValue(record)
  }, [record, form])

  const basicData = useMemo(() => {
    if (!show) {
      return {
        streams: [],
        pps: []
      }
    }
    const state = store.getState()
    const tpps = simulationData?.tpps || []
    const options = tpps.map(item => {
      return {value: item, label: item}
    })
    const streamsMap = {};
    const fsContent = getFSContentSelector(state)
    fsContent.sheets.forEach(sheet => {
      sheet.lines.forEach(line => {
        const streamId = line.streamId || line.id;
        streamsMap[streamId] = line;
      });
    });
    const streams = Object.values(streamsMap).map((stream: any) => {
      return {
        label: stream.tag,
        value: stream.id
      }
    })

    return {
      streams,
      pps: options
    }
  }, [show, simulationData])

  const onSave = async (values) => {
    if (!simId) return
    if (record) {
      await updatePPSTransitionRecords({...record, ...values}, {id: record.stream, sId: simId})
    } else {
      values.map = []
      await createPPSTransitionRecords(values, simId)
    }
    onSuccess?.()
    onClose()
  }

  const onClose = () => {
    form.resetFields()
    setShow(false)
  }

  const handleCancel = () => {
    onClose()
    onCancel?.()
  }

  return <>
    <span onClick={() => setShow(true)}>{trigger}</span>
    {<Modal
      open={show}
      title={`Create Physical Property Set Transition`}
      onOk={form.submit}
      onCancel={handleCancel}
      onClose={handleCancel}
    >
      <Form form={form} labelCol={{ span: 6 }} className="mt-1" onFinish={onSave}>
        <Form.Item name="stream" label="Stream" rules={[{ required: true }]}>
          <Select options={basicData.streams} disabled={!!record}/>
        </Form.Item>
        <Form.Item name="pps" label="Property Set" rules={[{ required: true }]}>
          <Select options={basicData.pps}/>
        </Form.Item>
        <Row>
          <Col span={6}></Col>
          <Col>
            <Form.Item name="isTransition" noStyle><CheckboxControl label="Is Transition" /></Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>}
  </>
}